import { Avatar, Box, Chip, Divider, Grid, Stack } from "@mui/material";
import Button from "components/Button";
import Select from "components/Input/Select";
import React, { useState } from "react";
import userImage from "assets/svg/gradient/user.svg";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import {
  getDefaultIconByType,
  keyValueFormat,
  linkByComponent,
} from "helpers/utils/utilities";
import Group from "@mui/icons-material/Group";
import EventNote from "@mui/icons-material/EventNote";
import SignalCellularAlt from "@mui/icons-material/SignalCellularAlt";
import Update from "@mui/icons-material/Update";
import moment from "moment";
import { isTrue } from "helpers/utils/validators";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import CollapsibleCard from "components/UI/molecules/CollapsibleCard";
import ComponentProfileCard from "components/UI/organisms/ComponentProfileCard";
import ChipsPreview from "components/UI/atoms/ChipsPreview";
import { BusinessCenterOutlined, SchoolOutlined } from "@mui/icons-material";
import ExperienceItem from "pages/profile/components/ExperienceItem";
import { Link } from "react-router-dom";
import { APPLICATION_STATUS } from "../forms/data";
import { logo as loadingLogo } from "assets/gif";
import useProfile from "store/profile/service-hook";
import { PDFDownloadLink } from "@react-pdf/renderer";
import DownloadProfile from "pages/profile/components/DownloadProfile";
import { NoDataView } from "components/UI/organisms/ListingContainer";

const ApplicationCard = ({
  data,
  col,
  handleUpdateApplicationStatus,
  manage,
  t = (d) => d,
}) => {
  const [loading, setLoading] = useState(false);
  const [profileInfo, setProfileInfo] = useState(null);
  const [downloadList, setDownloadList] = useState([]);
  const { getProfile, getDownloadProfileList } = useProfile();

  const loadProfileInfo = async (fromDownloadButton) => {
    if (!!profileInfo) return;
    setLoading(true);
    const res = await getProfile(data?.username);
    setProfileInfo(res);
    const res2 = await getDownloadProfileList(res?.id);
    setDownloadList(res2);
    setLoading(false);
    if (fromDownloadButton === true) {
      setTimeout(() => {
        const button = document.getElementById(
          `download-profile-${data?.username}`
        );
        if (button.href) window.open(button.href);
      }, 1000);
    }
  };

  return (
    <CollapsibleCard
      onExpand={loadProfileInfo}
      noExapandCollapse={col}
      showContent={
        <Grid container columnSpacing={2}>
          <Grid
            item
            xs={col ? 12 : 7}
            display="flex"
            flexDirection={col ? "column" : "row"}
            alignItems="center"
          >
            <Avatar
              src={data?.profile_image}
              className={`${!col ? "h-60 w-60" : "h-70 w-70"} bg-white`}
            >
              <img
                src={userImage}
                className={`${!col ? "h-60 w-60" : "h-70 w-70"}`}
              />
            </Avatar>
            <Box className={!col ? "ml-2" : "w-full my-2"}>
              <Link
                to={linkByComponent(COMPONENT_TYPES.USER, data?.username)}
                className="c-primary text-decoration-none"
              >
                <h2 className={`fs-22 fs-18--mob text-truncate ${col && "maxw-280"}`}>{data?.full_name}</h2>
              </Link>
              <Stack
                direction="row"
                whiteSpace="nowrap"
                alignItems="center"
                className="tracking-tight c-title fs-14"
              >
                {/* <Chip
                  label={data?.work_status}
                  size="small"
                  className="c-gray bg-gray"
                  sx={{
                    border: "1px solid #dadada",
                    borderRadius: "8px",
                    display: col && "none",
                  }}
                />
                <Divider
                  className={`h-25 mx-2 ${col && "hidden"}`}
                  variant="fullWidth"
                  orientation="vertical"
                /> */}
                <p>
                  {t("Date Applied")}: {moment(data?.date_applied).fromNow()}
                </p>
                {/* <Divider
                  className={`h-25 mx-2 ${col && "hidden"}`}
                  variant="fullWidth"
                  orientation="vertical"
                />
                <p className={`${col && "hidden"}`}>From Job Matching</p> */}
              </Stack>
            </Box>
          </Grid>
          <Grid
            item
            xs={col ? 12 : 5}
            display="flex"
            alignItems="center"
            justifyContent={col ? "space-between" : "flex-end"}
            mt={col && 1}
          >
            <Select
              name={data?.id}
              keyValues={keyValueFormat(APPLICATION_STATUS(true))}
              width={col ? "100%" : "200px"}
              height="30px"
              classes={`minh-30 ${col && "flex-1 w-full"}`}
              value={data?.status}
              t={t}
              onChange={handleUpdateApplicationStatus}
            />
            {!profileInfo ? (
              <Button
                width="100%"
                height="35px"
                classes={`fs-14 maxw-110 ${!col ? "mx-2" : "ml-2 flex-1"}`}
                loading={loading}
                onClick={() => loadProfileInfo(true)}
              >
                {t("Download")}
              </Button>
            ) : (
              <PDFDownloadLink
                document={
                  <DownloadProfile
                    profile={profileInfo}
                    labs={downloadList?.labs}
                    projects={downloadList?.projects}
                    hasMoreProjects={downloadList?.hasMoreProjects}
                    hasMoreLabs={downloadList?.hasMoreLabs}
                    t={t}
                  />
                }
                fileName={`${profileInfo?.username}.pdf`}
                id={`download-profile-${data?.username}`}
                className={`text-decoration-none maxw-110 ${
                  !col ? "mx-2" : "ml-2 flex-1"
                }`}
              >
                {(d) => (
                  <Button
                    width="110px"
                    height="35px"
                    classes="fs-14 w-110"
                    loading={d?.loading}
                    onClick={() => window.open(d?.url)}
                    disabled={d?.error || !profileInfo?.id}
                  >
                    {t("Download")}
                  </Button>
                )}
              </PDFDownloadLink>
            )}
          </Grid>
        </Grid>
      }
    >
      {loading ? (
        <Box className="flex items-center justify-center h-400 w-full">
          <img src={loadingLogo} alt="loader" height={100} />
        </Box>
      ) : profileInfo?.profile_privacy === "private" ? (
        <NoDataView
          small
          text="User has set profile privacy as private!"
          classes="my-6"
        />
      ) : (
        <>
          <h3>{t("About me")}</h3>
          <p
            className="fs-14"
            dangerouslySetInnerHTML={{ __html: profileInfo?.about }}
          />
          <h3 className="mt-4 flex items-center">
            <img
              src={getDefaultIconByType(COMPONENT_TYPES.LAB)}
              className="mr-1 h-30"
            />{" "}
            {t("Labs Completed")}
          </h3>
          {!downloadList?.labs?.length ? (
            <EmptyText>
              {t("This user has not completed a Lab, please check back later.")}
            </EmptyText>
          ) : (
            downloadList?.labs?.map((d, i) => (
              <ComponentProfileCard
                type={COMPONENT_TYPES.LAB}
                iconValueList={[
                  {
                    icon: Group,
                    value: `${d?.member_count || 0} ${t("Members")}`,
                  },
                  { icon: EventNote, value: d?.duration || "N/A" },
                  { icon: SignalCellularAlt, value: d?.level || "N/A" },
                  {
                    icon: Update,
                    value: d?.last_updated
                      ? `${t("Updated")} ${moment(
                          new Date(d?.last_updated)
                        ).fromNow()}`
                      : "N/A",
                  },
                  {
                    icon: isTrue(d?.privacy) ? VisibilityOff : Visibility,
                    value: t(isTrue(d?.privacy) ? "Private" : "Public"),
                  },
                ]}
                slug={d?.slug}
                subTitle={d?.organization}
                title={d?.title}
                description={d?.description}
                data={d}
              />
            ))
          )}
          <h3 className="mt-6 flex items-center">
            <img
              src={getDefaultIconByType(COMPONENT_TYPES.PROJECT)}
              className="mr-1 h-30"
            />{" "}
            {t("Projects")}
          </h3>
          {!downloadList?.projects?.length ? (
            <EmptyText>
              {t(
                "This user has not submitted a Project, please check back later."
              )}
            </EmptyText>
          ) : (
            downloadList?.projects?.map((d, i) => (
              <ComponentProfileCard
                type={COMPONENT_TYPES.PROJECT}
                slug={d?.slug}
                subTitle={d?.challenge?.title}
                title={d?.title}
                description={d?.description}
                data={d}
                t={t}
              />
            ))
          )}
          <h3 className="mt-6 mb-4 flex items-center">
            <img
              src={getDefaultIconByType(COMPONENT_TYPES.SKILL)}
              className="mr-1 h-30"
            />{" "}
            {t("Verified Skills")}
          </h3>
          {!Object.keys(profileInfo?.user_verified_skills || {})?.length ? (
            <EmptyText>
              {t(
                "This user has not verified any skill, please check back later."
              )}
            </EmptyText>
          ) : (
            <ChipsPreview
              items={Object.values(profileInfo?.user_verified_skills || {})}
              maxWidth={250}
            />
          )}

          <h3 className="mt-6 mb-4 flex items-center">
            <BusinessCenterOutlined fontSize="large" className="mr-1" />
            {t("Experience")}
          </h3>
          {!profileInfo?.user_experiences?.length ? (
            <EmptyText>
              {t(
                "This user has not provided any work experience, please check back later."
              )}
            </EmptyText>
          ) : (
            profileInfo?.user_experiences?.map((d, i) => (
              <ExperienceItem
                pl={0}
                t={t}
                key={d?.id}
                title={d?.company}
                subTitle={d?.position}
                address={d?.address}
                state={d?.state}
                country={d?.country}
                startDate={d?.start_date}
                endDate={d?.end_date}
                description={d?.description}
              />
            ))
          )}
          <h3 className="my-4 flex items-center">
            <SchoolOutlined fontSize="large" className="mr-1" />
            {t("Education")}
          </h3>
          {!profileInfo?.user_educations?.length ? (
            <EmptyText>
              {t(
                "This user has not provided any education background, please check back later."
              )}
            </EmptyText>
          ) : (
            profileInfo?.user_educations?.map((d) => (
              <ExperienceItem
                t={t}
                key={d?.id}
                pl={0}
                title={d?.university}
                subTitle={d?.degree}
                address={d?.address}
                startDate={d?.start_date}
                endDate={d?.end_date}
                description={d?.description}
                state={d?.state}
                country={d?.country}
              />
            ))
          )}
        </>
      )}
    </CollapsibleCard>
  );
};

export default ApplicationCard;

const EmptyText = ({ children }) => {
  return <p className="c-title fs-14 my-4">{children}</p>;
};
